<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">Standorte</h3>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <div v-if="loading" class="loading-container">
          <i class="fa fa-cog fa-spin"></i>
          <span>Daten werden geladen...</span>
        </div>
        <div class="card" v-if="!loading">
          <div class="card-body">
            <h4 class="card-title">Einrichtungen ({{ locations.length }})</h4>
            <b-form-select v-if="!isCustomer" v-model="stateFilter" :options="account_states"
              style="margin-bottom: 20px" />

            <form class="forms-sample" v-if="!isCustomer">
              <b-form-group label="" label-for="input1">
                <b-form-input v-model="invoicefilter" type="text" id="input1"
                  placeholder="Träger oder Einrichtung..."></b-form-input>
              </b-form-group>

              <div class="filter-chips">
                <b-button size="sm" :variant="sepaFilter ? 'primary' : 'outline-secondary'" @click="sepaFilter = !sepaFilter">
                  SEPA
                </b-button>
                <b-button size="sm" :variant="settlementFilter ? 'primary' : 'outline-secondary'" @click="settlementFilter = !settlementFilter">
                  Abr. fällig
                </b-button>
                <b-button size="sm" :variant="unpaidFilter ? 'primary' : 'outline-secondary'" @click="unpaidFilter = !unpaidFilter">
                  Offene Rechnungen
                </b-button>
                <b-button size="sm" :variant="noBillingsFilter ? 'primary' : 'outline-secondary'" @click="noBillingsFilter = !noBillingsFilter">
                  Keine Rechnung
                </b-button>
                <b-button size="sm" :variant="noticeFilter ? 'primary' : 'outline-secondary'" @click="noticeFilter = !noticeFilter">
                  Mit Anmerkung
                </b-button>
                <b-form-select size="sm" v-model="tagFilter" :options="availableTags" class="tag-select"></b-form-select>
                <b-button v-if="activeFilterCount > 0" size="sm" variant="outline-danger" @click="resetFilters">
                  <i class="fa fa-times"></i> Filter zurücksetzen ({{ activeFilterCount }})
                </b-button>
              </div>
            </form>
            <div v-title="'Somethings...'"></div>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="sortable-th" v-if="!isCustomer" @click="sortBy('category')">Träger <i :class="sortIcon('category')"></i></th>
                    <th class="sortable-th" v-if="!isCustomer" @click="sortBy('created_at')">Erstellt <i :class="sortIcon('created_at')"></i></th>
                    <th class="sortable-th" @click="sortBy('name')">Einrichtung <i :class="sortIcon('name')"></i></th>
                    <th class="sortable-th" @click="sortBy('next_settlement_stamp')">Nächste Abrechnung <i :class="sortIcon('next_settlement_stamp')"></i></th>
                    <th class="sortable-th" @click="sortBy('billings_count')">Rechnungen <i :class="sortIcon('billings_count')"></i></th>
                    <th v-if="!isCustomer">Abrechnung</th>
                    <th class="sortable-th" @click="sortBy('notice')">Notiz <i :class="sortIcon('notice')"></i></th>
                    <th class="sortable-th" @click="sortBy('billing_sepa')">SEPA <i :class="sortIcon('billing_sepa')"></i></th>
                    <th class="sortable-th" @click="sortBy('flutter_adopted_sort')">Flutter <i :class="sortIcon('flutter_adopted_sort')"></i></th>
                    <th class="sortable-th" @click="sortBy('account_tags_sort')">Tags <i :class="sortIcon('account_tags_sort')"></i></th>
                    <th v-if="isCustomer"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sortedLocations" :key="item.uid">
                    <td v-if="!isCustomer">
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.category }}</a>
                    </td>
                    <td v-if="!isCustomer">
                      {{ item.created_at | moment(" D.MM.YYYY") }}
                    </td>
                    <td>
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.name }}</a>
                    </td>
                    <td>
                      {{ item.next_settlement }}
                    </td>
                    <td>
                      {{ item.billings_count }}

                      ({{ item.unpaid_invoices }})
                      <i v-if="item.billing_alert && item.billing_alert == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td v-if="!isCustomer">
                      <i v-if="item.billing_check && item.billing_check.status === 'over'"
                        class="mdi mdi-24px mdi-circle" style="color: #ff463e; cursor: help;"
                        v-title="billingCheckTooltip(item)"></i>
                    </td>
                    <td>
                      <div v-if="item.notice && item.notice.length > 1" v-title="item.notice"><i
                          class="mdi  mdi-24px  mdi-clipboard-alert" style="color:#12CEB2;cursor:pointer;" /></div>
                    </td>
                    <td>
                      <i v-if="item.billing_sepa && item.billing_sepa == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td>
                      <i v-if="item.flutter_app_first_seen_at" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"
                        v-title="flutterTooltip(item)"></i>
                    </td>
                    <td>
                      <div v-for="item_account in item.account_tags" :key="item_account" class="badge-container">
                        <span class="badge-tag">{{ item_account }}</span>
                      </div>
                    </td>
                    <td style="text-align: right" v-if="isCustomer">
                      <router-link v-if="isCustomer" class="btn btn-outline-primary btn-fw" :to="{
                        name: 'location-customer',
                        params: { uid: item.uid },
                      }">Anzeigen</router-link>
                      <router-link v-if="!isCustomer" target="_blank" class="btn btn-outline-primary btn-fw" :to="{
                        name: 'location-detail',
                        params: { uid: item.uid },
                      }">Anzeigen</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="sortedLocations && sortedLocations.length === 0" class="empty-state">
                <i class="mdi mdi-filter-remove-outline"></i>
                <p>Keine Einrichtungen für diese Filter gefunden.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAll } from "@/services/locations.service";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      stateFilter: "customer",
      loading: true,
      sepaFilter: false,
      settlementFilter: false,
      unpaidFilter: false,
      noBillingsFilter: false,
      noticeFilter: false,
      tagFilter: null,
      invoicefilter: null,
      sortKey: 'name',
      sortOrder: 'asc',
      account_states: [
        { text: "Test", value: "test" },
        { text: "Kunde", value: "customer" },
        { text: "Kostenlose Nutzung", value: "forfree" },
        { text: "Geschlossen", value: "close" },

      ],
    };
  },
  computed: {
    sortedLocations: function () {
      let locations = this.locations;

      if (this.sortKey) {
        locations = locations.slice().sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (valA == null) valA = '';
          if (valB == null) valB = '';

          if (typeof valA === 'string' && typeof valB === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (this.sortOrder === 'asc') {
            return valA > valB ? 1 : valA < valB ? -1 : 0;
          } else {
            return valA < valB ? 1 : valA > valB ? -1 : 0;
          }
        });
      }

      return locations;
    },
    availableTags: function () {
      var tags = [{ text: 'Alle Tags', value: null }];
      if (!this.$store.state.locations) return tags;

      var seen = {};
      for (var i = 0; i < this.$store.state.locations.length; i++) {
        var loc = this.$store.state.locations[i];
        if (loc.account_tags && loc.account_tags.length) {
          for (var j = 0; j < loc.account_tags.length; j++) {
            var tag = loc.account_tags[j];
            if (!seen[tag]) {
              seen[tag] = true;
              tags.push({ text: tag, value: tag });
            }
          }
        }
      }
      return tags;
    },
    locations: function () {
      if (!this.$store.state.locations) {
        return;
      }

      return this.$store.state.locations.filter((item) => {
        // SEPA Filter
        const sepaMatch = !this.sepaFilter || (item.billing_sepa === 'y');

        // Settlement Filter
        const settlementMatch = !this.settlementFilter || (() => {
          if (!item.next_settlement) return false;

          const [day, month, year] = item.next_settlement.split('.');
          const settlementDate = new Date(year, month - 1, day);
          const today = new Date();

          today.setHours(0, 0, 0, 0);
          settlementDate.setHours(0, 0, 0, 0);

          return settlementDate <= today;
        })();

        // Offene Rechnungen Filter
        const unpaidMatch = !this.unpaidFilter || (item.unpaid_invoices > 0);

        // Noch keine Rechnung Filter
        const noBillingsMatch = !this.noBillingsFilter || (item.billings_count == 0);

        // Anmerkung Filter
        const noticeMatch = !this.noticeFilter || (item.notice && item.notice.length > 0);

        // Tag Filter
        const tagMatch = !this.tagFilter || (item.account_tags && item.account_tags.indexOf(this.tagFilter) !== -1);

        // Bestehende Filter
        const stateMatch = item.account_state == this.stateFilter;
        const searchMatch = !this.invoicefilter ||
          (item.category &&
            item.category
              .toString()
              .toLowerCase()
              .indexOf(this.invoicefilter.toLowerCase()) != -1) ||
          (item.name &&
            item.name
              .toString()
              .toLowerCase()
              .indexOf(this.invoicefilter.toLowerCase()) != -1);

        // Kombiniere alle Filter
        return stateMatch && searchMatch && sepaMatch && settlementMatch
          && unpaidMatch && noBillingsMatch && noticeMatch && tagMatch;
      });
    },
    activeFilterCount: function () {
      var count = 0;
      if (this.sepaFilter) count++;
      if (this.settlementFilter) count++;
      if (this.unpaidFilter) count++;
      if (this.noBillingsFilter) count++;
      if (this.noticeFilter) count++;
      if (this.tagFilter) count++;
      if (this.invoicefilter) count++;
      return count;
    },
    isCustomer: function () {
      return (
        this.$store.state.user_customer &&
        this.$store.state.user_company &&
        this.$store.state.user_company.length > 2
      );
    },
  },
  methods: {
    sortIcon: function (key) {
      if (this.sortKey !== key) return 'fa fa-sort sort-icon sort-icon-inactive';
      return this.sortOrder === 'asc' ? 'fa fa-sort-asc sort-icon' : 'fa fa-sort-desc sort-icon';
    },
    resetFilters: function () {
      this.sepaFilter = false;
      this.settlementFilter = false;
      this.unpaidFilter = false;
      this.noBillingsFilter = false;
      this.noticeFilter = false;
      this.tagFilter = null;
      this.invoicefilter = null;
    },
    sortBy: function (key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    // Indikator erscheint NUR bei Unterlizenzierung (status 'over':
    // mehr aktive Kinder als abgerechnet). ok/under/unknown werden
    // bewusst nicht angezeigt.
    billingCheckTooltip: function (item) {
      var bc = item.billing_check;
      if (!bc) return '';
      return 'aktiv ' + bc.childs_count + ' / abgerechnet ' + bc.billed_childs +
        ' (mehr aktive als abgerechnete Kinder)';
    },
    flutterTooltip: function (item) {
      if (!item.flutter_app_first_seen_at) return 'Flutter-App noch nicht im Einsatz';
      var parts = [];
      if (item.flutter_app_last_seen_at) {
        parts.push('Zuletzt aktiv ' + this.moment(item.flutter_app_last_seen_at).format(' D.MM.YYYY hh:mm'));
      }
      if (item.flutter_app_version) {
        parts.push('Version ' + item.flutter_app_version);
      }
      return parts.length ? parts.join(' · ') : 'Flutter-App im Einsatz';
    },
    generateLink(uid) {
      return this.$router.resolve({
        name: 'location-detail',
        params: { uid }
      }).href;
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    this.loading = true;

    getAll().then((resp) => {
      this.loading = false;
      console.log(resp, "-");
      if (resp.data.error) {
        localStorage.removeItem("token");
        this.$router.push({ name: "login" });
      } else {
        this.$store.state.locations = resp.data.locations;
        this.$store.state.user_customer = resp.data.customer;
        this.$store.state.user_company = resp.data.company;


        for (let i = 0; i < this.$store.state.locations.length; i++) {
          var loc = this.$store.state.locations[i];

          if (!loc.billing_sepa || loc.billing_sepa != "y") {
            loc.billing_sepa = "n"
          }

          loc.account_tags_sort = loc.account_tags && loc.account_tags.length
            ? loc.account_tags.join(', ')
            : '';

          // Sort key for the Flutter adoption column: adopted rows sort by their
          // first-seen timestamp, not-adopted rows sort to the bottom (empty string).
          loc.flutter_adopted_sort = loc.flutter_app_first_seen_at || '';
        }

      }
    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9c9fa6;
}

.loading-container i {
  font-size: 40px;
  margin-bottom: 12px;
}

.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
}

.filter-chips .tag-select {
  width: auto;
  min-width: 140px;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.sortable-th:hover {
  color: #198ae3;
}

.sort-icon {
  font-size: 11px;
  margin-left: 4px;
}

.sort-icon-inactive {
  opacity: 0.3;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #9c9fa6;
}

.empty-state i {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

.badge-container {
  margin-bottom: 5px;
}

.badge-tag {
  color: #ffffff;
  background-color: #198ae3;
  padding: 4px 5px 4px 5px;
  font-size: 12px;
  display: inline-block;
}

.link-col {
  color: #0077cc;
  text-decoration: none;
}

.link-col:hover {
  color: #005fa3;
}

.link-col:visited {
  color: #551A8B;
}
</style>